// ── A FAIXA DO FIM DO TUTORIAL, POR CIMA DA PARTIDA ──────────────────────────
// O ✓ grande, sem uma frase na tela (a Poki recusou o Web Fit Test de 28/09 por texto: "players on Poki
// really don't like reading"), por `app.parabensAte`. Cobre o handshake (com a rodinha enquanto a sala não
// conecta) e os primeiros segundos da partida. A frase existe, inteira, no `aria-label`.
//
// ⚠️ ELA JÁ FOI A FAIXA DA SKIN EM TESTE ("o Marte · ○○○ · 🎁 — este planeta vira seu em 3 partidas"), com
//    uma segunda cara na morte sem tela (`pipsAte`, as bolinhas). As duas saíram quando o mascote passou a
//    ser DADO no nascimento da conta (ver `MASCOT_SKINS` em shared/src/skins.js): não há mais promessa a
//    fazer, e o planeta da primeira sala é o mesmo do tutorial desde o primeiro frame.
// ⚠️ **AVISA, NÃO PEDE CLIQUE** — a regra do `#notice`, no mesmo canto dele: `pointer-events:none`, sem
//    botão, some pelo prazo.
// ⚠️ **QUEM A APOSENTA É O RELÓGIO DO HUD, não um timer daqui**: `Hud.jsx` é reavaliado a 8 Hz enquanto há
//    partida, então `Date.now() >= ate` basta — um `setTimeout` próprio seria um segundo relógio para a
//    mesma pergunta. O prazo mora no TOPO do store, fora de `overlays`, que `play()` reescreve inteiro.
// ⚠️ Só em `screen:"game"`: se a vida acabar antes do prazo, a faixa não sobe por cima da tela de morte.
// ⚠️ `indo` (a sala ainda não conectou) esconde o RESTO do HUD por CSS: entre o fim do tutorial e o primeiro
//    snapshot da sala os blocos da partida mostrariam números velhos do tutorial ou zeros — ver `ui.css`.
import React from "react";
import { useStore } from "../state/store.js";
import { app } from "../state/app.js";
import { useLabels } from "../hooks/useTheme.js";

export default function TutorParabens() {
  const LB = useLabels();
  const ate = useStore(app, s => s.parabensAte);
  const screen = useStore(app, s => s.screen), conn = useStore(app, s => s.conn);
  if (screen !== "game" || !ate || Date.now() >= ate) return null;
  const T = LB.tutor || {};
  const indo = conn !== "connected";
  return <div id="tutor-parabens" className={"fim" + (indo ? " indo" : "")}
    role="status" aria-live="polite" aria-label={T.fimTitulo}>
    <i className="tpb-ok" aria-hidden="true">✓</i>
    {indo ? <i className="tpb-roda" aria-hidden="true" /> : null}
  </div>;
}
